export const PAYMENT_LIST_STATUS_FOR_FILTER = [
	{name: 'All', column: '', count: 0},
	{name: 'Pending', column: 'pending', count: 0},
	{name: 'Completed', column: 'completed', count: 0},
	{name: 'On Hold', column: 'on_hold', count: 0},
	{name: 'Failed', column: 'failed', count: 0},
	{name: 'Refunded', column: 'refunded', count: 0},
	{name: 'Canceled', column: 'canceled', count: 0},
	{name: 'Expired', column: 'expired', count: 0},
];